import { Component, Input } from '@angular/core';

@Component({
  selector: 'email-footer',
  templateUrl: './email-footer.component.html',
  styleUrl: './email-footer.component.scss'
})
export class EmailFooterComponent {

   @Input() html: any = '';

}
